export * from '@thalesrc/js-utils/math/min-max';
